module.exports = __webpack_public_path__ + "img/26.ca3d01c0.png";